"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { ChatProvider } from "@/context/ChatContext";

interface ConditionalChatProviderProps {
  children: ReactNode;
}

/**
 * Conditional wrapper for ChatProvider
 * Only loads ChatProvider on the messages page to keep the app lightweight
 * WebSocket connections are only created on the messages page
 * Other pages use lightweight polling for notifications
 */
export function ConditionalChatProvider({
  children,
}: ConditionalChatProviderProps) {
  const pathname = usePathname();
  const isMessagesPage = pathname?.startsWith("/messages") ?? false;

  // Only render ChatProvider on messages page
  // This ensures WebSocket connections are only created on the messages page
  // Other pages use lightweight polling hooks for notifications
  if (isMessagesPage) {
    return <ChatProvider>{children}</ChatProvider>;
  }

  // Don't load ChatProvider on other pages - keeps the app lightweight
  return <>{children}</>;
}
